import { render, staticRenderFns } from "./MiniRatings.vue?vue&type=template&id=2b8d2d79&scoped=true"
import script from "./MiniRatings.vue?vue&type=script&lang=js"
export * from "./MiniRatings.vue?vue&type=script&lang=js"
import style0 from "./MiniRatings.vue?vue&type=style&index=0&id=2b8d2d79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d2d79",
  null
  
)

export default component.exports